import { Injectable } from '@angular/core';
import { DividendPayoutFrequency, folioDataSchema, InvestorFolio, InvestorFolioScheme, InvestorScheme, masterScheme, selectSchemeToSchema } from '@root/modules/common/models/investor-details';
import { InvesmentModeSchema, InvestmentDetailSchema } from '@transactions/models/investment-details.model';
import { PaymentDetailSchema } from '@transactions/models/payment-detail.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataHandlerService {

  selectedFolio: InvestorFolio;
  schemesUnderSelectedFolio: InvestorFolioScheme;
  selectedScheme: InvestorScheme;
  investmentModeDetails: InvesmentModeSchema;
  planListForParticularScheme: DividendPayoutFrequency[];
  investmentDetails: InvestmentDetailSchema;
  paymentDetails: PaymentDetailSchema;
  paymentEndDate: string;
  paymentStartDate: string;
  transactionId: string;
  urnNo: string;
  transactionType: string;
  selectedSchemeToDetails: selectSchemeToSchema;
  plansArray: string[];
  optionArray: { optDesc: string; optionCode: string }[];
  switchFromSchemeSchemesApi : masterScheme[];
  switchToSchemeSchemesApi : masterScheme;
  folioData : folioDataSchema;
  selectedSchemeForReinvestOrTransact : any;
  selectedSchemeForSipTransact:any;
  distributorArns: {arnCode: string;}[];
  subDistributorArns: {arnCode: string;}[];
  selectedOption: string;
  resetTransactionJourney : boolean = true;
  context:string;
  invMode:string;
  failureErrorMessage: string;
  usaCanFlag: boolean;
  linkFolioFlag:boolean = false;
  private jointHolderSubject = new BehaviorSubject<any>(null);
  jointHolderData$ = this.jointHolderSubject.asObservable();

  constructor() { }

  setSelectedFolioDetails(folio: InvestorFolio) {
    this.selectedFolio = folio;
  }

  getSelectedFolioDetails() {
    return this.selectedFolio;
  }

  setFolioData(folio) {
    this.folioData = folio;
  }

  getFolioData() {
    return this.folioData;
  }

  setSchemesUnderSelectedFolio(schemes: InvestorFolioScheme) {
    this.schemesUnderSelectedFolio = schemes;
  }

  getSchemesUnderSelectedFolio() {
    return this.schemesUnderSelectedFolio;
  }

  setSelectedScheme(scheme) {
    this.selectedScheme = scheme;
  }

  getSelectedScheme() {
    return this.selectedScheme;
  }

  setSelectedSchemeToDetails(scheme) {
    this.selectedSchemeToDetails = scheme;
  }

  getSelectedSchemeToDetails() {
    return this.selectedSchemeToDetails;
  }

  setInvestmentModeDetails(details) {
    this.investmentModeDetails = details;
  }

  getInvestmentModeDetails() {
    return this.investmentModeDetails;
  }

  setFilteredPlanListForSchemeSelected(details) {
    this.planListForParticularScheme = details;
  }

  getFilteredPlanListForSchemeSelected() {
    return this.planListForParticularScheme;
  }

  setInvestmentDetails(details) {
    this.investmentDetails = details;
  }

  getInvestmentDetails() {
    return this.investmentDetails;
  }

  setPaymentDetails(details) {
    this.paymentDetails = details;
  }

  getPaymentDetails() {
    return this.paymentDetails;
  }

  setStartDate(date) {
    this.paymentStartDate = date;
  }

  getStartDate() {
    return this.paymentStartDate;
  }

  setEndDate(date) {
    this.paymentEndDate = date;
  }

  getEndDate() {
    return this.paymentEndDate;
  }

  setTransactionId(date) {
    this.transactionId = date;
  }

  setTransactionFailureErrorMessage(errorMessage) {
    this.failureErrorMessage = errorMessage;
    console.log(errorMessage);
  }

  getTransactionFailureErrorMessage() {
    return this.failureErrorMessage;
  }

  getTransactionId() {
    return this.transactionId;
  }

  setUrnNumber(date) {
    this.urnNo = date;
  }

  getUrnNumber() {
    return this.urnNo;
  }

  setTransactionType(transaction) {
    this.transactionType = transaction;
  }

  getTransactionType() {
    return this.transactionType;
  }

  setPlanArray(plans) {
    this.plansArray = plans;
  }

  getPlanArray() {
    return this.plansArray;
  }

  setOptionArray(plans) {
    this.optionArray = plans;
  }

  getOptionArray() {
    return this.optionArray;
  }

  setSwitchFromSchemeSchemesApi(scheme:masterScheme[]) {
    this.switchFromSchemeSchemesApi = scheme;
  }

  getSwitchFromSchemeSchemesApi() {
    return this.switchFromSchemeSchemesApi;
  }

  setSwitchToSchemeSchemesApi(scheme:masterScheme) {
    this.switchToSchemeSchemesApi = scheme;
  }

  getSwitchToSchemeSchemesApi() {
    return this.switchToSchemeSchemesApi;
  }

  setSelectedSchemeForReinvestOrTransact(scheme) {
    this.selectedSchemeForReinvestOrTransact = scheme;
  }

  getSelectedSchemeForReinvestOrTransact() {
    return this.selectedSchemeForReinvestOrTransact;
  }
  setSelectedSchemeForSipTransact(scheme) {
    this.selectedSchemeForSipTransact = scheme;
  }

  getSelectedSchemeForSipTransact() {
    return this.selectedSchemeForSipTransact;
  }

  setDistributorArns(details) {
    this.distributorArns = details;
  }

  getDistributorArns() {
    return this.distributorArns;
  }

  setSubDistributorArns(details) {
    this.subDistributorArns = details;
  }

  getSubDistributorArns() {
    return this.subDistributorArns;
  }

  setSelectedOption(details) {
    this.selectedOption = details;
  }

  getSelectedOption() {
    return this.selectedOption;
  }

  setResetTransactionJourney(status:boolean) {
    this.resetTransactionJourney = status;
  }

  getResetTransactionJourney() {
    return this.resetTransactionJourney;
  }


  setContext(context:string){
    this.context = context;
  }

  getContext(){
    return !this.context ? 'TRANSATION': this.context;
  }

  setInvMode(mode: string){
    this.invMode = mode;
  }

  getInvMode(){
    return this.invMode;
  }

  setUsaCanadaResidentFlag(mode: boolean){
    this.usaCanFlag = mode;
  }
  
  getUsaCanadaResidentFlag(){
    return this.usaCanFlag
  }
  
  setLinkFolioFlag(mode: boolean){
    this.linkFolioFlag = mode;
  }

  getLinkFolioFlag(){
    return this.linkFolioFlag;
  }

  setSecondaryHolderFlag(data: any) {
    this.jointHolderSubject.next(data);
  }
}
